<script>
// 仅导入父组件，无需导入Draw
import { tool } from '@CesiumCommon';
import DrawBase from './drawBase.vue';
import { getAreaInfo } from '../../../../../../modules/common/Util/src/amapUtils';
import UtilS from '@/page/business/util/map.js';

export default {
    extends: DrawBase,
    render() {
        return null;
    },
    watch: {
        selectLDrawType: {
            handler(type) {
                if (this.geometryType === 'Polygon' && type) {
                    this.initMap()
                        .then(() => {
                            if (this.map && this.VectorSource) {
                                this.onAddInteraction();
                            } else {
                                console.error('地图或数据源初始化失败，无法创建Draw交互');
                            }
                        })
                        .catch((err) => {
                            console.error('初始化地图失败：', err);
                        });
                }
            },
            immediate: true,
        },
    },
    methods: {
        // Polygon专用样式函数
        styleFunction(feature) {
            let styles;

            // 警戒线样式
            if (this.selectLDrawType.includes('warningLine')) {
                styles = this.createOLStyle({
                    stroke: this.createOLStroke({
                        color: this.warningLineStyle.color,
                        width: this.warningLineStyle.width,
                    }),
                });
            }
            // 拦截范围样式
            else if (this.selectLDrawType === 'intercept') {
                styles = this.createOLStyle({
                    stroke: this.createOLStroke({
                        color: '#49F0FDFF',
                        width: 2,
                    }),
                    fill: this.createOLFill({
                        color: '#49F0FD66',
                    }),
                });
            }
            // 交通管制多边形
            else if (this.selectLDrawType === 'Traffic-polygon' || this.selectLDrawType === 'Traffic-square') {
                styles = this.createOLStyle({
                    stroke: this.createOLStroke({
                        color: 'red',
                        width: 2,
                    }),
                    fill: this.createOLFill({
                        color: '#9A161C61',
                    }),
                });
            }
            // 嫌疑人多边形
            else if (this.selectLDrawType === 'suspicion-polygon' || this.selectLDrawType === 'suspicion-square') {
                styles = this.createOLStyle({
                    stroke: this.createOLStroke({
                        color: '#FDCE54FF',
                        width: 2,
                    }),
                    fill: this.createOLFill({
                        color: '#FDCE544D',
                    }),
                });
            }

            return styles;
        },

        // Polygon绘制交互（调用父组件createOLDraw方法）
        onAddInteraction() {
            if (!this.map) {
                console.error('map 实例不存在，无法添加 Draw 交互');
                return;
            }
            if (!this.VectorSource) {
                console.error('VectorSource 不存在，无法创建 Draw 交互');
                this.VectorSource = this.createOLVectorSource({ wrapX: false });
            }

            this.removeDraw();

            try {
                // 调用父组件封装的Draw创建方法
                this.draw = this.createOLDraw({
                    type: 'Polygon',
                    style: this.styleFunction.bind(this),
                });

                this.map.addInteraction(this.draw);
                this.bindDrawEndEvent();
            } catch (err) {
                console.error('创建 Draw 交互失败：', err);
                this.draw = null;
            }
        },

        // 绘制完成事件逻辑
        bindDrawEndEvent() {
            this.draw.on('drawend', async (e) => {
                try {
                    const Coordinates = e.feature.getGeometry().getCoordinates();
                    e.feature.setId(Coordinates[0][0]);
                    let params;

                    // 警戒线
                    if (this.selectLDrawType.includes('warningLine')) {
                        let name = '';
                        if (this.selectLDrawType === 'warningLine-1') name = '标记一级警戒线';
                        if (this.selectLDrawType === 'warningLine-2') name = '标记二级警戒线';
                        if (this.selectLDrawType === 'warningLine-3') name = '标记三级警戒线';

                        this.$emit('addDataEvent', {
                            name: `${name}-${new Date().getTime()}`,
                            geometryType: 'Polygon',
                            geometry: UtilS.polygonToWKT(Coordinates[0]),
                        }, 'canvas');
                    }
                    // 拦截范围
                    else if (this.selectLDrawType === 'intercept') {
                        let center = UtilS.getPointsCenter(Coordinates[0]);
                        let CoordinatesGcj02 = tool.transform.wgs84togcj02(
                            Number(center.longitude),
                            Number(center.latitude),
                        );
                        let location = await getAreaInfo(`${CoordinatesGcj02[0]},${CoordinatesGcj02[1]}`);
                        location = JSON.parse(location.currentTarget.response).regeocode.addressComponent;
                        location = `${location.district}${location.township}${location.streetNumber.street}`;

                        // 计算污染物距离和拦截时间
                        let pollutantList = this.drawInfoList.filter((item) => item.obj === '视频测面积');
                        let pollutantArr = pollutantList.map((item) => ({
                            id: item.id,
                            distance: tool.distance(
                                { longitude: item.json['2d'].center.longitude, latitude: item.json['2d'].center.latitude },
                                { longitude: center.longitude, latitude: center.latitude },
                            ),
                        }));
                        let pollutantMinObj = pollutantArr.sort((a, b) => a.distance - b.distance)[0];
                        const pollutantDistance = pollutantMinObj ? `${pollutantMinObj.distance} m` : '0';

                        let measuringSpeedList = this.drawInfoList.filter((item) => item.obj === '视频测流速');
                        let measuringSpeedArr = measuringSpeedList.map((item) => ({
                            id: item.id,
                            distance: tool.distance(
                                { longitude: item.json['2d'].CoordinatesFirst[0], latitude: item.json['2d'].CoordinatesFirst[1] },
                                { longitude: center.longitude, latitude: center.latitude },
                            ),
                        }));
                        let distanceMinObj = measuringSpeedArr.sort((a, b) => a.distance - b.distance)[0];
                        let measuringSpeedObj = measuringSpeedList.find((item) => item.id === distanceMinObj?.id);
                        let speed = measuringSpeedObj ? measuringSpeedObj.json['2d'].speed : 0;
                        let interceptTime = pollutantMinObj ? (pollutantMinObj.distance / speed) * 1000 : 0;
                        interceptTime = new Date(Date.now() + interceptTime).toLocaleString();

                        params = {
                            drawType: 'Polygon',
                            drawObj: '拦截范围',
                            mark: '拦截范围',
                            location,
                            positions: Coordinates,
                            color: '#49F0FDFF',
                            fillColor: '#49F0FD66',
                            width: 2,
                            pollutantDistance,
                            interceptTime,
                        };
                        // await this.saveDrawInfo(params);
                    }
                    // 交通管制多边形/方形
                    else if (this.selectLDrawType === 'Traffic-polygon' || this.selectLDrawType === 'Traffic-square') {
                        params = {
                            drawType: 'Polygon',
                            drawName: this.selectLDrawType === 'Traffic-polygon' ? '标记管制区域-多边形' : '标记管制区域-方形',
                            drawObj: this.selectLDrawType === 'Traffic-polygon' ? '管制区域-多边形' : '管制区域-方形',
                            mark: this.selectLDrawType === 'Traffic-polygon' ? '多边形' : '方形',
                            positions: Coordinates,
                            color: 'red',
                            width: 2,
                            fillColor: '#9A161C61',
                        };
                        // await this.saveDrawInfo(params);
                    }
                    // 嫌疑人多边形/方形
                    else if (this.selectLDrawType === 'suspicion-polygon' || this.selectLDrawType === 'suspicion-square') {
                        params = {
                            drawType: 'Polygon',
                            drawName: this.selectLDrawType === 'suspicion-polygon' ? '标记嫌疑人' : '标记嫌疑人范围-方形',
                            drawObj: this.selectLDrawType === 'suspicion-polygon' ? '嫌疑人' : '嫌疑人范围-方形',
                            mark: this.selectLDrawType === 'suspicion-polygon' ? '嫌疑人' : '方形',
                            positions: Coordinates,
                            color: '#FDCE54FF',
                            width: 2,
                            fillColor: '#FDCE544D',
                        };
                        //  this.$emit('addDataEvent', {
                        //     ...caseParams,
                        //     longitude: Coordinates[0],
                        //     latitude: Coordinates[1],
                        // }, 'suspicion');
                        // await this.saveDrawInfo(params);
                    }
                    this.removeDraw();
                } catch (err) {
                    console.error('处理绘制完成事件失败：', err);
                }
            });
        },
    },
};
</script>
